import { Injectable } from "@angular/core";
import { BreadcrumbsClient, BreadcrumbsViewModel } from "src/domain/client";
import { ChannelRequestService } from "./channel-request.service";

@Injectable({
  providedIn: "root",
})
export class BreadcrumbsService {
  constructor(private channelRequestService: ChannelRequestService) {}

  getCategoryHierarchyByProductId(
    productId: number,
  ): Promise<BreadcrumbsViewModel[]> {
    return new BreadcrumbsClient().byProductId(
      productId,
      this.channelRequestService.channelRequest?.channelRequestId,
    );
  }

  getCategoryHierarchyByCategoryId(
    categoryId: number,
  ): Promise<BreadcrumbsViewModel[]> {
    return new BreadcrumbsClient().byCategoryId(categoryId);
  }
}
